<app-menu-common url="sales"></app-menu-common>
<app-offline-banner></app-offline-banner>

@if (!hasFseConfig) {
  <app-offline-banner type="warning" icon="warning" [show]="true" [compact]="true" message="Profil FSE / PS non configuré pour cet utilisateur : consultation seule (actions de télétransmission et d'extraction désactivées)."> </app-offline-banner>
}

<div class="fses-page">
  <!-- ══════════════════════════════════════════════════════════════════════════
  SÉLECTEUR — Titre, Filtres FSE, Actions Rechercher / Effacer
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="toolbar-card">
    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">receipt_long</mat-icon>
      <span>Suivi de facturation (FSEs)</span>
    </div>

    <div class="filters-inline" (keydown)="onKeydown($event)">
      <div class="filter-item">
        <label class="filter-label" for="flt-num">Numéro</label>
        <input id="flt-num" #searchInput class="custom-input num-input" placeholder="N° facture" [(ngModel)]="filters.numFacture" />
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-datdeb">Date début</label>
        <input id="flt-datdeb" class="custom-input date-input" placeholder="JJ/MM/AAAA" [(ngModel)]="filters.datdeb" />
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-datfin">Date fin</label>
        <input id="flt-datfin" class="custom-input date-input" placeholder="JJ/MM/AAAA" [(ngModel)]="filters.datfin" />
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-recipient">Bénéficiaire / Assuré</label>
        <input id="flt-recipient" class="custom-input recipient-input" placeholder="Bénéficiaire / Assuré" [(ngModel)]="filters.recipient" />
      </div>

      <div class="filter-item status-filter-item">
        <label class="filter-label" for="flt-status">État</label>
        <mat-select id="flt-status" class="custom-select state-select" [(ngModel)]="filters.etats" multiple placeholder="Tous les états">
          @for (state of stateList; track state.code) {
            <mat-option [value]="state.code">{{ state.label }}</mat-option>
          }
        </mat-select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-datcpt">Dat Compt.</label>
        <input id="flt-datcpt" class="custom-input date-input" placeholder="Dat Comptable" [(ngModel)]="filters.datcpt" />
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-orgamo">Payeur AMO</label>
        <input id="flt-orgamo" class="custom-input org-input" placeholder="Org. Payeur AMO" [(ngModel)]="filters.orgAmo" />
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-paiement">Mnt. Payé</label>
        <input id="flt-paiement" class="custom-input amount-input" placeholder="Mnt. Payé" [(ngModel)]="filters.paiement" />
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-libvirt">Lib. Virt.</label>
        <input id="flt-libvirt" class="custom-input lib-input" placeholder="Lib. Virement" />
      </div>
    </div>

    <div class="toolbar-actions">
      <button mat-stroked-button class="btn-inline btn-ghost" aria-label="Rechercher" title="Lancer la recherche" (click)="onClickSearch()">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-flat-button class="error btn-inline" aria-label="Effacer" title="Réinitialiser les filtres" (click)="onClickClear()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
  TABLEAU : Liste des factures FSE + Actions FSE (télétransmission, bordereau…)
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="content-row">
    <div class="table-card">
      <!-- Barre de la carte : identité, compteur, date et actions FSE -->
      <div class="table-header-bar">
        <div class="header-left">
          <div class="table-title">
            <mat-icon>receipt_long</mat-icon>
            <span>Factures FSE</span>
            <span class="badge-count">{{ dataSource_db.data.length }}</span>
          </div>
          <span class="daydate-chip">{{ util.getFormattedDate() }}</span>
        </div>

        <div class="header-right">
          <div class="actions-group">
            <button mat-stroked-button class="header-btn" type="button" aria-label="Bordereau Ordos" title="Générer le bordereau des ordonnances" (click)="onClickBordereau()" [disabled]="!hasFseConfig">
              <mat-icon>receipt</mat-icon>
              <span>Bordereau Ordos</span>
            </button>
            <button mat-stroked-button class="header-btn" type="button" aria-label="Actualiser" title="Actualiser les retours (Lots, RSPs, SCOR)" (click)="onClickActualiser()" [disabled]="!hasFseConfig">
              <mat-icon>refresh</mat-icon>
              <span>Actualiser</span>
            </button>
            <button mat-flat-button color="primary" class="teletransmettre-btn" type="button" aria-label="Télétransmettre" title="Mettre en lot, en fichier et télétransmettre" (click)="onClickTeletransmettre()" [disabled]="!hasFseConfig">
              <mat-icon>send</mat-icon>
              <span>Télétransmettre</span>
            </button>
            <button mat-icon-button class="menu-btn" [matMenuTriggerFor]="fseMenu" aria-label="Actions détaillées FSE" title="Actions détaillées" [disabled]="!hasFseConfig">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #fseMenu="matMenu">
              <button mat-menu-item (click)="onClickExtraireLots()">
                <mat-icon>cloud_download</mat-icon>
                <span>Extraire Lots</span>
              </button>
              <button mat-menu-item (click)="onClickExtraireRSPs()">
                <mat-icon>receipt_long</mat-icon>
                <span>Extraire RSPs</span>
              </button>
              <button mat-menu-item (click)="onClickExtraireSCOR()">
                <mat-icon>description</mat-icon>
                <span>Extraire SCOR</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="onClickMettreEnLot()">
                <mat-icon>inventory_2</mat-icon>
                <span>Mettre en Lots</span>
              </button>
              <button mat-menu-item (click)="onClickMettreEnFichier()">
                <mat-icon>folder_zip</mat-icon>
                <span>Mettre en Fichiers</span>
              </button>
              <button mat-menu-item (click)="onClickTeletransmissionSolo()">
                <mat-icon>upload</mat-icon>
                <span>Télétransmission</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>

      <!-- Table responsive container -->
      @if (dataSource_db) {
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource_db" class="fses-table">
            <ng-container matColumnDef="numFacture">
              <th mat-header-cell *matHeaderCellDef class="col-num">#</th>
              <td mat-cell *matCellDef="let p" class="col-num">
                <!--p is a FSEOrder -->
                <a class="facture-link" (click)="onClickFSE($event, p); $event.stopPropagation()">{{ p.data.factureFR.numFacture }}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="dateFacture">
              <th mat-header-cell *matHeaderCellDef class="col-date">Date Fact.</th>
              <td mat-cell *matCellDef="let p" class="col-date">{{ p.data.factureFR.dateFacture }}</td>
            </ng-container>

            <ng-container matColumnDef="flux">
              <th mat-header-cell *matHeaderCellDef class="col-flux">DRE ?</th>
              <td mat-cell *matCellDef="let p" class="col-flux">{{ p.data?.processingResult?.areaResponse?.HTTPResponse?.factureFR?.typeFluxCree }}</td>
            </ng-container>

            <ng-container matColumnDef="id_order">
              <th mat-header-cell *matHeaderCellDef class="col-order">Cde.</th>
              <td mat-cell *matCellDef="let p" class="col-order">
                <a class="order-link" [routerLink]="['/sales/quotation', p.id_order]" target="_blank" (click)="onIDOrderClick($event)">{{ p.id_order }}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="nir">
              <th mat-header-cell *matHeaderCellDef class="col-nir">NIR</th>
              <td mat-cell *matCellDef="let p" class="col-nir">{{ p.data.factureFR.beneficiaire.numSecu }}</td>
            </ng-container>

            <ng-container matColumnDef="bs">
              <th mat-header-cell *matHeaderCellDef class="col-bs">Bénéficiaire</th>
              <td mat-cell *matCellDef="let p" class="col-bs">{{ p.data.factureFR.beneficiaire.nom }}&nbsp;-&nbsp;{{ p.data.factureFR.beneficiaire.prenom }}</td>
            </ng-container>

            <ng-container matColumnDef="fse_type">
              <th mat-header-cell *matHeaderCellDef class="col-type">Type Fact.</th>
              <td mat-cell *matCellDef="let p" class="col-type">{{ p.type_facture }}</td>
            </ng-container>

            <ng-container matColumnDef="fse_state">
              <th mat-header-cell *matHeaderCellDef class="col-state">État Fact.</th>
              <td mat-cell *matCellDef="let p" class="col-state">
                <span class="state-badge">{{ p.etat_facture }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="mnt_tot">
              <th mat-header-cell *matHeaderCellDef class="col-amount text-right">Mnt Tot</th>
              <td mat-cell *matCellDef="let p" class="col-amount text-right font-medium">{{ p.totalRemboursable | fc }}</td>
            </ng-container>

            <ng-container matColumnDef="mnt_amo">
              <th mat-header-cell *matHeaderCellDef class="col-amount text-right">Mnt AMO</th>
              <td mat-cell *matCellDef="let p" class="col-amount text-right">{{ p.remboursableAmo }}</td>
            </ng-container>

            <ng-container matColumnDef="du_amo">
              <th mat-header-cell *matHeaderCellDef class="col-amount text-right">Mnt dû</th>
              <td mat-cell *matCellDef="let p" class="col-amount text-right text-due">{{ p.totalDu | fc }}</td>
            </ng-container>

            <ng-container matColumnDef="mnt_amc">
              <th mat-header-cell *matHeaderCellDef class="col-amount text-right">Mnt AMC</th>
              <td mat-cell *matCellDef="let p" class="col-amount text-right">{{ p.remboursableAmc }}</td>
            </ng-container>

            <ng-container matColumnDef="org_amo">
              <th mat-header-cell *matHeaderCellDef class="col-org col-group-left">Org AMO</th>
              <td mat-cell *matCellDef="let p" class="col-org col-group-left">{{ p.data.factureFR.beneficiaire.attestationAMO.regime }}{{ p.data.factureFR.beneficiaire.attestationAMO.caisseGest }}{{ p.data.factureFR.beneficiaire.attestationAMO.centreGest }}</td>
            </ng-container>

            <ng-container matColumnDef="org_amc">
              <th mat-header-cell *matHeaderCellDef class="col-org">Org AMC</th>
              <td mat-cell *matCellDef="let p" class="col-org">{{ p.orgAmc == '99999997' ? 'Coordonné' : p.orgAmc }}</td>
            </ng-container>

            <ng-container matColumnDef="batch">
              <th mat-header-cell *matHeaderCellDef class="col-batch">Lot FSE</th>
              <td mat-cell *matCellDef="let p" class="col-batch">{{ p.lnk_batch_fse?.ref_lot }}</td>
            </ng-container>

            <ng-container matColumnDef="batch_date">
              <th mat-header-cell *matHeaderCellDef class="col-batch-date">Date Lot FSE</th>
              <td mat-cell *matCellDef="let p" class="col-batch-date amocol">{{ p.lnk_batch_fse?.date_heure_etat_lot ?? '' | isoDateTransform }}</td>
            </ng-container>

            <ng-container matColumnDef="batch_state">
              <th mat-header-cell *matHeaderCellDef class="col-batch-state col-group-right">État Lot FSE</th>
              <td mat-cell *matCellDef="let p" class="col-batch-state col-group-right">
                @if (p.lnk_batch_fse?.etat_lot) {
                  <button mat-button class="lot-btn" (click)="onClickDetailLot($event, p, 'FSE')" [ngClass]="p.etatRSPFSEClass">{{ p.lnk_batch_fse?.etat_lot }}</button>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="batch_dre">
              <th mat-header-cell *matHeaderCellDef class="col-batch">Lot DRE</th>
              <td mat-cell *matCellDef="let p" class="col-batch">{{ p.lnk_batch_dre?.ref_lot }}</td>
            </ng-container>

            <ng-container matColumnDef="batch_date_dre">
              <th mat-header-cell *matHeaderCellDef class="col-batch-date">Date Lot DRE</th>
              <td mat-cell *matCellDef="let p" class="col-batch-date">{{ p.lnk_batch_dre?.date_heure_etat_lot ?? '' | isoDateTransform }}</td>
            </ng-container>

            <ng-container matColumnDef="batch_state_dre">
              <th mat-header-cell *matHeaderCellDef class="col-batch-state col-group-right">État Lot DRE</th>
              <td mat-cell *matCellDef="let p" class="col-batch-state col-group-right">
                @if (p.lnk_batch_dre?.etat_lot) {
                  <button mat-button class="lot-btn" (click)="onClickDetailLot($event, p, 'DRE')" [ngClass]="p.data.annulDRE ? 'etat-rsp-rejet' : p.etatRSPDREClass">{{ p.data.annulDRE ? 'ANNULÉE' : p.lnk_batch_dre?.etat_lot }}</button>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="attach">
              <th mat-header-cell *matHeaderCellDef class="col-action-icon"><mat-icon class="header_icon">attach_file</mat-icon></th>
              <td mat-cell *matCellDef="let p" class="col-action-icon">
                @if (p?.lnk_docs?.length > 0) {
                  <button mat-icon-button class="table-icon-btn" (click)="opendossiersscore($event, p, true)" title="Pièces justificatives SCOR">
                    <mat-icon class="material-symbols-outlined" [style.color]="p.attach_icon.color">{{ p.attach_icon.icon }}</mat-icon>
                  </button>
                } @else if (!['NOUVELLE FSE', 'TARIFICATION', 'MODELE_LOCATION'].includes(p.etat_facture)) {
                  <button mat-icon-button class="table-icon-btn" (click)="opendossiersscore($event, p, true)" title="Pièce justificative manquante">
                    <mat-icon class="material-symbols-outlined warning-icon">warning</mat-icon>
                  </button>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef class="col-action-icon"><mat-icon class="header_icon">delete</mat-icon></th>
              <td mat-cell *matCellDef="let p" class="col-action-icon">
                @if (!p.lnk_batch_fse && p.etat_facture !== 'MODELE_LOCATION') {
                  <button mat-icon-button class="table-icon-btn" (click)="onClickDeleteOrder(p); $event.stopPropagation()" title="Supprimer la facture">
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="print">
              <th mat-header-cell *matHeaderCellDef class="col-action-icon"><mat-icon class="header_icon">print</mat-icon></th>
              <td mat-cell *matCellDef="let p" class="col-action-icon">
                <button mat-icon-button class="table-icon-btn" [disabled]="['NOUVELLE FSE', 'TARIFICATION', 'MODELE_LOCATION'].includes(p.etat_facture)" (click)="onClickPrint(p); $event.stopPropagation()" title="Imprimer duplicata / quittance">
                  <mat-icon>print</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns_db"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns_db" class="row invoicerow" (click)="onClickDetailPrestation($event, row)" [ngClass]="row.etatFactureRSPClass"></tr>
          </table>
        </div>

        @if (dataSource_db.data.length === 0) {
          <div class="empty-orders">
            <mat-icon class="empty-icon">receipt_long</mat-icon>
            <div class="empty-title">Aucune facture FSE</div>
            <div class="empty-subtitle">Aucune facture FSE ne correspond aux filtres de recherche.</div>
            <button mat-stroked-button color="primary" class="action-btn" (click)="onClickClear()">
              <mat-icon>clear</mat-icon>
              Réinitialiser les filtres
            </button>
          </div>
        }
      }

      <!-- Fses in Area (ready to batch) BUT missing from mek DB => should be investigated destroyed/sent by another mean...  -->
      @if (searcher) {
        <div class="area-mismatch-banner">
          <mat-icon>info</mat-icon>
          <span
            >Nombre de FSE dans la base Area prêtes à mettre en lot mais absentes de la base Mercalink : <strong>{{ searcher.getMaplength() }}</strong></span
          >
        </div>
      }
    </div>
  </div>
</div>
